module.exports = __webpack_public_path__ + "img/logoFooter.a46d168a.png";